module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading.fullscreen.lock",
      value: (_vm.loading),
      expression: "loading",
      modifiers: {
        "fullscreen": true,
        "lock": true
      }
    }],
    attrs: {
      "element-loading-text": _vm.loadingText
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "wrapper"
    }
  }, [_c('main-top-tabs'), _vm._v(" "), _c('main-top-bar'), _vm._v(" "), _c('main-left-menu'), _vm._v(" "), _c('div', {
    staticClass: "content-page"
  }, [_c('div', {
    class: ['content', _vm.contentRightBarClass]
  }, [_c('div', {
    staticClass: "container"
  }, [_c('keep-alive', [(_vm.isSessionLoaded) ? _c('router-view') : _vm._e()], 1)], 1)])])], 1), _vm._v(" "), _c('main-custom'), _vm._v(" "), _c('main-modals'), _vm._v(" "), _c('main-bottom-right-buttons')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-38ac3c85"}!./~/vue-loader/lib/selector.js?type=template&index=0!./libs/@db2b/keystone/components/Templates/Layouts/MainLayout.vue
// module id = 684
// module chunks = 1